export default "{\n    \"chipLabel\": \"NUEVO\"\n}\n"